// src/components/sections/Hero.jsx
import React from "react";
import { motion } from "framer-motion";
import Button from "../ui/Button";
import { useTranslation } from "react-i18next";

const RESERVATION_URL = "https://reservations.allo.restaurant/de/golden-arm-indisches-restaurant";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <div className="relative h-screen flex items-center overflow-hidden">
      {/* Background video */}
      <div className="absolute inset-0 z-0">
        {/* <video autoPlay muted loop className="w-full h-full object-cover">
          <source src="/assets/videos/goldenarm.mp4" type="video/mp4" />
        </video> */}
        <video
  autoPlay
  muted
  loop
  playsInline
  preload="auto"
  className="w-full h-full object-cover"
>
  <source src="/assets/videos/goldenarm.mp4" type="video/mp4" />
  {/* Optional fallback for older devices */}
  Your browser does not support the video tag.
</video>
        <div className="absolute inset-0 bg-black bg-opacity-50" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center md:text-left">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src="/assets/images/main-logo (1).png"
            alt="Golden Arm Logo"
            className="h-36 md:h-48 mx-auto md:mx-0"
          />
          <p className="mt-6 text-white text-2xl md:text-3xl font-display">{t("description1")}</p>
          <div className="mt-6">
            <Button to="/menu">{t("viewMenu")}</Button>
          </div>
        </motion.div>
      </div>

      {/* Floating reservation card at bottom-right */}
      <motion.div
        className="absolute bottom-8 right-8 hidden lg:block z-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
      >
        <div className="rounded-2xl bg-accent/95 backdrop-blur px-8 py-7 shadow-xl border border-white/10 max-w-xs">
          <h3 className="font-display text-2xl text-primary mb-3">{t("makeReservation")}</h3>
          <p className="text-primary/90 mb-5">{t("clickToBook")}</p>
          <a
            href={RESERVATION_URL}
            className="inline-flex items-center justify-center rounded-full border-2 border-secondary text-secondary font-semibold px-5 py-2 hover:bg-secondary/10 transition"
          >
            {t("reserveNow")}
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default Hero;
